<template>
   <div :id="'containerSetPhone'" class="textfieldScreen">
      <div class="leftContent">
         <custom-header :img-number="1"></custom-header>
      </div>
      <div class="rightContent" >
         <div class="headBlock">
            <custom-header />
         </div>
         <div class="wrap textfieldScreen_content">
            <h2 v-html="$ml.get('setPhoneTitle')"></h2>
            <login-input
                    id="textfield"
                    name="textfield"
                    v-model="inputValue"
                    :selectArray="selectArray"
                    @selectItemSet="selectedItem"
            ></login-input>
            <div class="grow"></div>
            <slot name="middle"></slot>
            <div class="bottom">
               <div class="left">
                  <custom-button
                          :button-text="$ml.get('back')"
                          back
                          :action="back"
                  ></custom-button>
               </div>
               <div class="right">
                  <custom-button
                          :button-text="$ml.get('next')"
                          success
                          :action="startLogin"
                  ></custom-button>
               </div>
            </div>
            <div class="bottomLink">
               <a class="link" @click.stop="nextScreen" v-text="$ml.get('setPhoneBottomText')">Не пам’ятаю номер телефону</a>
            </div>
         </div>
      </div>
   </div>

</template>

<script>
    import TextfieldScreen from "../../components/layout/textfield-screen";
    import CustomButton from "../../components/ui/custom-button";
    import CustomHeader from "../../components/ui/custom-header";
    import LoginInput from "../../components/ui/login-input";
    export default {
         name: "setPhonePage",
         components: {LoginInput, CustomHeader, CustomButton, TextfieldScreen},
       data() {
            return {
               inputValue: '',
               selectArray: [
                  {
                      number: '380',
                     logo: '<img src="../static/flags/uk.png" alt="Українська">',
                     name: '',
                     maskPlaceholder: '+380',
//                     mask: ['+', /\d/,/\d/,' ','(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
                  },
                  {
                      number: '381',
                     logo: '<img src="../static/flags/ru.png" alt="Українська">',
                     name: '',
                     maskPlaceholder: '+381',
//                     mask: ['+', /\d/,/\d/,' ','(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
                  },
                  {
                      number: '382',
                     logo: '<img src="../static/flags/en.png" alt="Українська">',
                     name: '',
                     maskPlaceholder: '+382',
//                     mask: ['+', /\d/,/\d/,' ','(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]
                  },
               ],
               currentSelectItem: null,
            }
       },
         methods: {
            nextScreen: function () {
               this.$router.push({ name: 'AccessRecoverySetEmail'});
            },
            startLogin: function () {
               this.$router.push({ name: 'LoginEnterCode'});
            },
            back: function () {
               this.$router.back();
            },
            selectedItem: function (data) {
               this.currentSelectItem = data;
            },
         }
    }
</script>

<style lang="scss" scoped>
   .link {
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
   }
   .textfieldScreen_content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-height: calc(100vh - 150px);
   }
   .bottom {
      .left {
         width: 40%;
         float: left;
      }
      .right {
         width: 56%;
         float: right;
      }
   }
   @media (min-width: 601px) and (max-width: 750px) {
      .textfieldScreen_content {
         height: calc(100vh - 220px);
         max-height: 700px;
      }
   }
   @media (min-width: 751px) {
      .textfieldScreen_content {
         height: calc(100vh - 220px);
         max-height: 700px;
      }
   }
</style>